import './footer.scss'

export default function Footer() {
    return (
        <div className='footer'>
            <h3>@2022 | created with ❤ by Madhurima Banerjee</h3>
        </div>
    )
}
